import { render, staticRenderFns } from "./SystemPlaces.vue?vue&type=template&id=382bd628&scoped=true"
import script from "./SystemPlaces.vue?vue&type=script&lang=js"
export * from "./SystemPlaces.vue?vue&type=script&lang=js"
import style0 from "./SystemPlaces.vue?vue&type=style&index=0&id=382bd628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382bd628",
  null
  
)

export default component.exports